const heroSwiper = new Swiper('.full-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 400,
    autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        waitForTransition: false
    },
    allowTouchMove: true,
    pagination: {
        el: '#hero-header-swiper-pagination',
        clickable: true,
        type: 'bullets',
    },
});